<template>
  <div class="template" v-if="newAllBetEvent.od[plytyp]">
    <template v-for="btype in btypes" v-if="newAllBetEvent.od[plytyp][btype] != undefined">
      <div data-template="template3" class="wrap-template template3">
        <div class="main-handicap">
          <div class="vrow items-center template-title is_fold">
            <div class="play-name col" @click="showLeg()">
              <span class="ellipsis">{{ getTitleCaption(btype) }}</span>
            </div>
            <div class="" v-if="newAllBetEvent.sprbinfo"><span class="ellipsis">{{ sportTableLang.table['SPORT_TABLE.CURRENT_TOTAL'] }}: {{ newAllBetEvent.sprbinfo.scoa }}-{{ newAllBetEvent.sprbinfo.scob }}</span></div>
            <div style="width: 37px;" @click="setToTop($event)">
              <span class="set_top" style="display: none;">
                <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
              </span>
            </div>
          </div>
          <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][btype]).length)">
            <template v-if="newAllBetEvent.od[plytyp][btype][Object.keys(newAllBetEvent.od[plytyp][btype])[subMatchKey]]">
              <template v-if="show">
                <div class="handicap">
                  <div class="handicap-item m-oe os-1 no_border_bottom">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="item-label bet-ellipsis ellipsis">
                              <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_ODD'] }}</span>
                            </div>
                            <span class="ellipsis"></span>
                          </div>
                        </div>
                        <odd :event="newAllBetEvent" :team="teamA" :plyType="plytyp" :betType="btype" :match="subMatchKey"
                          ref="teamOdd" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item m-oe os-1 no_border_bottom">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="item-label bet-ellipsis ellipsis">
                              <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_EVEN'] }}</span>
                            </div>
                            <span class="ellipsis"></span>
                          </div>
                        </div>
                        <odd :event="newAllBetEvent" :team="teamB" :plyType="plytyp" :betType="btype" :match="subMatchKey"
                          ref="teamEven" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd'
import HandicapComponents from '../../../components/handicap'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().oeBetType, allBetMixin.data().roeBetType],
      show: true,
      shdp: ['7', '8', '9', '10', '11', '12'],
      gamePt: ['14', '15', '16', '17', '18'],  //game 1-5 playtype
      pt: {
        7: '1',
        8: '2',
        9: '3',
        10: '4',
        11: '5',
        12: '6',
      },
      gamePtLang: {
        '14': '1',
        '15': '2',
        '16': '3',
        '17': '4',
        '18': '5',
      }
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption(btype) {
      var a = ''
      var pt = ''
      var bt = ''
      var sCapt = ''
      if (this.plytyp == this.ftPlyType) {
        a = '_FT'
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H'
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H'
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP'
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP'
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP'
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') { /*** Set ***/
        a = '_' + this.pt[this.plytyp] + 'SET'
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') {  /*** Game ***/
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME'
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS'
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS'
      }else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS'
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS'
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS'
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS'
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS'
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS'
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS'
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS'
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS'
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME'
      }

      pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a]  // Play Type
      bt = this.sportAllBetLang['ALL_BET.SUBHEADER_OE'] //  Bet Type
      
      if (this.isSpecial) {
        var st = this.specialLeagueCaption(this.newAllBetEvent, this.btype)
        sCapt = ' '+ st + ' (' + this.sportAllBetLang['ALL_BET.LBL_SPECIALS'] + ')'
      }

      return pt + bt + sCapt
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    addToMyMarket(plytyp, oeBetType) {
      if (this.selectMarket)
        this.selectMarket(this.newAllBetEvent, plytyp, oeBetType, this.isSpecial)
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    removeFromMyMarket(plytyp, oeBetType) {
      if (this.removeMarket)
        this.removeMarket(this.newAllBetEvent, plytyp, oeBetType, this.isSpecial)
    },
    oddsHeader() {
      var retCapt = ''
      if (this.isSpecial) {
        retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.oeBetType)
      }

      return retCapt
    }
  },
  mounted(){
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }else{
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-oe.vue